function getAddress(candidate: RTCIceCandidate): string {
  //          0           1  2       3           4        5    6
  // candidate:4256570884 1 udp 2122260223 10.24.132.75 54261 typ host generation 0 ufrag y0DB network-id 6
  const csParts = candidate.candidate.split(' ');
  return csParts[4];
}

/**
 * Deduplicate candidates with the same address.
 */
export default function deduplicateCandidates(
  candidates: RTCIceCandidate[]
): RTCIceCandidate[] {
  const addresses = new Set();
  return candidates.reduce((acc: RTCIceCandidate[], next: RTCIceCandidate) => {
    const addr = getAddress(next);
    if (!addresses.has(addr)) {
      addresses.add(addr);
      return [...acc, next];
    }
    return acc;
  }, []);
}
